<app-header [selectedMenu]="selectedMenu"></app-header>

<div class="container" (scroll)="onScrollTop($event)">

  <!-- div class="wrapper" #main
       (click)="onFocusMain($event)" -->
  <div class="wrapper">
    <aside class="rope"
           (click)="onClickRope($event)">
    </aside>
    <app-back-btn></app-back-btn>

    <section class="search-all">

      <div class="inner wrap">

        <div class="all-map-box">

          <!-- 사투리 영상 페이지가 아니면 지도에서는 지역을 표시하지 않는다 -->
          <app-dialect-region-map [city]="subPath === 'region' ? selectedCity : CITY2_DEFAULT"
                                  [region]="selectedRegion"
                                  (zoomRegion)="onZoomRegion($event)"
                                  (changeRegion)="onCityChange($event)"></app-dialect-region-map>

        </div>
        <div class="all-contents-box flex-column">

          <app-search-box-dialect [keyword]="keyword"
                                  [placeholder]="placeholder"
                                  [keyHistoryKeyword]="HISTORY_KEY_SEARCH_DIALECT"
                                  [keyHistoryView]="HISTORY_KEY_VIEW_DIALECT"
                                  [top]="scrollTop"
                                  (search)="onSearch($event)"
                                  (goHistory)="onGoHistory()"></app-search-box-dialect>

          <router-outlet></router-outlet>

        </div>

      </div>


    </section>

  </div>

  <!-- app-footer></app-footer -->

  <app-common-popups></app-common-popups>

</div>

<article class="msg-layer-popup"
         *ngIf="showMsgPopup" [@msgPopupFadeOut]>
  <div class="msg-layer">왼 쪽 지도에서 지역을 선택을 하면,<br/>그 지역의 우리말이 보입니다.</div>
</article>
